import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: /*#__PURE__*/_normalizeClass(`fs14 centered mt5 fw600 whiteColor pad5`),
  style: {"margin-top":"30px"}
}, "画像をアップロードまたは選択", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: "UploadImageButton centered pointer posRe fl ddgreyBg w100 rad10 mt20",
    style: `height: 60px;line-height:60px;`,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickButton && _ctx.clickButton(...args)))
  }, [
    _createElementVNode("img", {
      src: _ctx.$getAssetImageUrl(`/assets/icons/camera_wt.png`),
      class: "mr10",
      width: "33",
      height: "32",
      style: {"margin-top":"-7px"}
    }, null, 8, _hoisted_1),
    _hoisted_2
  ]))
}